export const Global = {
  domainUrl: '',
  LOG_OFF_API: 'awcp/user/logout',
  GENESYS_LOGOUT: 'awcp/user/genesysLogout',
  LOGIN_API: 'awcp/user/authenticate',
  TBA_GUI_REGISTER_API: 'awcp/tbaguiwf/authenticateRACFID',
  TBA_GUI_GET_DATA_API: 'awcp/tbaguiwf/getTBAGUIWebFrontData',
  GET_APP_CONFIG: 'awcp/common/getApplicationConfigurations',
  IS_DUPLICATE_SESSION: 'awcp/sso/checkActiveSession',
  GET_USER_DETAILS: 'awcp/user/getUserDetails/',
  HANDLE_MULTI_SESSION: 'awcp/user/handleMultiSession',
  HANDLE_MULTI_SESSION_SSO: 'awcp/user/handleMultiSessionSSO',
  UPDATE_USER_QUEUE: 'awcp/user/updateUserQueue',
  // GET_IH_BRIEF_DATA: 'awcp/interactionhistory/getInteractions',
  //GET_IH_LIST_DATA: 'awcp/interactionhistory/getInteractionsListDetails',
  GET_IH_BRIEF_DATA: 'awcp/interactionhistory/topIHDocMsgsData',
  GET_IH_LIST_DATA: 'awcp/interactionhistory/ihDocMsgsListDetails',
  GET_REPEAT_ALERT: 'awcp/interactionhistory/interactionDataBycontactIdAndDays',
  UPDATE_CUSTOMER_EC: 'awcp/api/customer/updateCustomerInElasticCache',
  GET_SSO_LINK: 'awcp/api/link/getLinkUrl',
  isSessionActive: 'awcp/user/isSessionActive',
  DELETE_CUSTOMER_EC: 'awcp/api/customer/deleteCustomer/',
  UPDATE_USER_EC: 'awcp/user/updateUser',
  ALERTS_TEMPLATES: 'awcp/alerts/templates',
  CREATE_ALERTS: 'awcp/api/alerts',
  SAVE_EDIT_ALERTS: 'awcp/api/alerts/',
  GET_TOPIC_LIST: 'awcp/wrapup/getTopicsList',
  GET_DOCUMENT_CONTENT: 'awcp/documents/viewDocument',
  GET_MESSAGE_CONTENT: 'awcp/documents/viewMessage',
  GET_AGENT_INTERACTION_DATA: 'awcp/interactionhistory/agentIHData',
  GET_CLIENT_MAPPING: 'awcp/user/getUserClientSystemMapping',
  GET_USER_CLIENT_PROPERTY: "awcp/user/getUserClientProperty",
  LOAD_TEST_USER_LOGIN : 'awcp/sso/loadTestLogin',



  ssoLogin: {
    testApi: 'awcp/sso/',
    getConfigDetails: 'awcp/common/getApplicationConfigurations',
  },
  customerApi: {
    fetchCustomerData: 'awcp/customerSearch/fetchCustomerData',
    getCustomersession: 'awcp/api/customer/session',
    csPro: 'awcp/api/v1/customer/fetchCsPro',
    customerType: 'awcp/api/v1/customer/getCustomerType',
    sql: 'awcp/api/v1/customer/fetchPostgreSql',
    CustomerData: 'awcp/api/v1/customer/fetchCustomerData',
    hasPro: 'awcp/api/v1/customer/fetchHasBro',
    AD: 'awcp/api/v1/customer/fetchAD/',
    lambda: 'awcp/api/v1/customer/fetchLambda',
    clientResponseList: 'awcp/user/getUserClientEntitlements',
    getClientSystemMapping: 'awcp/client/getClientSystemMapping',
    getRestoreAccountDetails: "awcp/api/customer/getRestoreAccountDetails",
    getTopicListByDomain: 'awcp/api/link/getTopicListByDomain',
    getTbaKcArticleLinks: 'awcp/api/link/getTbaKcArticleLinks',
    getApprovedExceptionLists: 'awcp/approvedException/getApprovedExceptionList',
    getEgainContent: 'awcp/egain/fetchEgainContent',
    autoLaunchAPI :'awcp/api/link/autoLaunchConfig',
    clientInfoCardDefaultPinService : 'awcp/usersettings/userPinService'
  },
  openAccountApi: {
    GetOpenAccountDetails: 'openAccount/Get',
    getPersonData: 'awcp/person/getPersonData',
    customerNavigation: 'awcp/navigation/menu',
    getRoleTypeList: 'awcp/person/listsOfParticipantRoles',
  },
  authenticationApis: {
    gethenticationContentList: 'awcp/authentication/getAuthenticationContentList',
    fetchEgainContent: 'awcp/egain/fetchEgainContent',
    validateIndicativeData: 'awcp/validate/indicativeData'
  },
  dashboardApi: {
    getCaseManagementDetails: 'awcp/api/link/getLinks',
    ValidValuesApi: 'awcp/common/getValidValuesByValidFieldKey',
    SAVE_PREFERENCE_VALUE: 'awcp/usersettings/updateFeatureSetting/ALIS',
    dashboardLeftNavigation: 'awcp/navigation/menu'
  },
  customerAccountApi: {
    getCaseManagementDetail: 'awcp/api/link/getLinks',
  },
  backendDetailsAPI: {
    getBuildDetail: 'awcp/application/buildDetails',
  },


};

export const ActionEnum = Object.freeze({
  Save: 'a',
  Edit: 'e',
  Delete: 'd',
  Cancel: 'c',
});
